import { notifyParent } from 'Helpers/notifyParent'
import useRedirectorUrl from 'Hooks/useRedirectorUrl'
import { PageHeader } from 'mailup-web-components'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useHistory } from 'react-router'
import { useRecoilValue } from 'recoil'
import { campaignState } from '../recoil/state/campaign'

const Header = () => {
  const intl = useIntl()
  const history = useHistory()
  const [redirectUrl] = useRedirectorUrl()
  const { Name, Id } = useRecoilValue(campaignState)

  const statusEditLabel =
    Id > 0
      ? intl.formatMessage({ id: 'Load.NavMenu.Edit' })
      : intl.formatMessage({ id: 'Load.NavMenu.Create' })
  const breadcrumbsItems = [
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.Automation' }),
      'data-mu-test': 'breadcrumb-item__automation',
      className: 'test-breadcrumb-item__automation'
    },
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.Content' }),
      'data-mu-test': 'breadcrumb-item__content',
      className: 'test-breadcrumb-item__content',
      url: '#',
      onClick: () => history.push('/automation/sources/list')
    },
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.ContentsCampaignList' }),
      'data-mu-test': 'breadcrumb-item__automation-ContentsCampaignList',
      className: 'test-breadcrumb-item__automation-ContentsCampaignList',
      url: '#',
      onClick: () => history.push('/automation/contentsCampaign/list')
    },
    {
      label: statusEditLabel,
      'data-mu-test': `breadcrumb-item__automation-workflow-${statusEditLabel}`,
      className: `test-breadcrumb-item__automation-workflow-${statusEditLabel}`
    }
  ]

  useEffect(() => {
    notifyParent('selectMenuItemReact', [
      Id > 0 ? 'ContentsCampaignEdit' : 'ContentsCampaignNew',
      redirectUrl
    ])
  }, [Id, redirectUrl])

  return (
    <PageHeader
      breadcrumbsItems={breadcrumbsItems}
      title={
        !Id
          ? intl.formatMessage({
              id: 'Load.AutomationWorkflow.AutomationUntitled'
            })
          : Name
      }
      loading={Id ? !Name : false}
    />
  )
}

export default Header
